const ProductsEndpoint = {
  new (form) {
    return {
      url: '/products',
      method: 'POST',
      body: JSON.stringify({product: form})
    }
  },
  index () {
    return {
      url: `/products`,
      method: 'GET'
    }
  },
  reservation_index (company_id) {
    return {
      url: `/product_reservations?company_id=${company_id}`,
      method: 'GET'
    }
  },
  show (id) {
    return {
      url: `/products/${id}`,
      method: 'GET'
    }
  },
  update (id, form) {
    return {
      url: `/products/${id}`,
      method: 'PUT',
      body: JSON.stringify({ product: form })
    }
  }
}

export default ProductsEndpoint



// WEBPACK FOOTER //
// ./src/persistence/ProductsEndpoint.js